import React from 'react';
import { useAPIContext } from '../../../context/api';
import { AnyCreativityConfig, CreativityType } from '../../../types/banner';
import { BannerMediaFiles } from '../../../../../types/brands';
import { BrandsAPI } from '../../../../../constructs/brands/interface';
import { EditorModelInput } from '../../../../../constructs/brands/banners/save-editor-banner/interface';

export const useSaveEditorBanner = () => {
  const { callEndpoint } = useAPIContext();

  const saveEditorBanner = React.useCallback(
    async (
      bannerId: string,
      creativityType: CreativityType,
      config: AnyCreativityConfig,
      title: string,
      mediaFiles: BannerMediaFiles[],
      editorModels?: EditorModelInput[],
      folder?: string
    ) => {
      try {
        const res = await callEndpoint<BrandsAPI, 'save-editor-banner'>('brands', '/creativities/editor', 'POST', {
          bannerId,
          creativityType,
          config,
          title,
          mediaFiles,
          editorModels,
          folder
        });

        if (!res) throw new Error('Respuesta del servidor inesperada');

        return res;
      } catch (error) {
        console.error('Error al guardar el banner:', error);
        return null;
      }
    },
    [callEndpoint]
  );

  return { saveEditorBanner };
};
